import Http from '../../http';
import { startLoadingList, stopLoadingList } from '../../common/hoc/withLoaingList';

export const fetchStaffMember = (ownerType, ownerId, staffMemberId) =>
  Http.get(`/${ownerType}/${ownerId}/staff/${staffMemberId}`);

export const updateStaffMember = (brandId, staffId, data) =>
  Http.put(`/brand/${brandId}/staff/${staffId}`, data);

export const createStaffMember = (brandId, data) =>
  Http.post(`/brand/${brandId}/staff`, data);

export const restoreDeletedStaffMember = (brandId, staffId) =>
  Http.post(`/brand/${brandId}/staff/${staffId}/restore`);

export const deleteStaffMember = staffId =>
  Http.delete(`/user/${staffId}`);

export const fetchStaffMembers = (ownerType, ownerId) => (dispatch) => {
  dispatch(startLoadingList());

  return Http.get(`/${ownerType}/${ownerId}/staff`)
    .then(result => (result ? result.users : []))
    .then(staffMembers => staffMembers.filter((staffMember) => {
      if (!staffMember.enabled) {
        return false;
      }

      return ownerType === 'brand' || !staffMember.brandId;
    }))
    .finally(() => {
      dispatch(stopLoadingList());
    });
};

export const fetchDeletedStaffMembers = (ownerType, ownerId) => (dispatch) => {
  dispatch(startLoadingList());

  return Http.get(`/${ownerType}/${ownerId}/staff?withDeleted=true`)
    .then(result => (result ? result.users : []))
    .then(staffMembers => staffMembers.filter((staffMember) => {
      if (!staffMember.deletedAt) {
        return false;
      }

      return ownerType === 'brand' || !staffMember.brandId;
    }))
    .finally(() => {
      dispatch(stopLoadingList());
    });
};
